import { createFileRoute } from "@tanstack/react-router"

const parseNumberSearchParam = (value: unknown) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : undefined
  }

  if (typeof value !== "string" || value.trim() === "") {
    return undefined
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : undefined
}

const parseBooleanSearchParam = (value: unknown): boolean | undefined => {
  if (value === true || value === 1 || value === "1" || value === "true") {
    return true
  }
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false
  }
  return undefined
}

export const Route = createFileRoute("/map/")({
  validateSearch: (search) => ({
    stationId:
      typeof search.stationId === "string" ? search.stationId : undefined,
    lat: parseNumberSearchParam(search.lat),
    lng: parseNumberSearchParam(search.lng),
    zoom: parseNumberSearchParam(search.zoom),
    targetId:
      typeof search.targetId === "string" && search.targetId.length > 0
        ? search.targetId
        : undefined,
    showRoute: parseBooleanSearchParam(search.showRoute),
  }),
})
